module.exports = __webpack_public_path__ + "img/calendar.ff9ceb11.svg";